module.exports = __webpack_public_path__ + "img/pinwall-logo-new - Copy.6754874c.svg";